export const FEEDBACK_CONTEXT_LABELS = {
  TESTS: 'bitbucket-tests',
  MERGE_QUEUES: 'bitbucket-merge-queues',
  MERGE_QUEUES_SETTINGS: 'bitbucket-merge-queues-settings',
  AGENTIC_PIPELINES: 'bitbucket-agentic-pipelines',
  DEPLOYMENTS: 'bitbucket-deployments',
} as const;

export type FeedbackContextLabel =
  (typeof FEEDBACK_CONTEXT_LABELS)[keyof typeof FEEDBACK_CONTEXT_LABELS];

// All pipelines feedback features share a single Atlaskit entrypoint ID by design.
// The `feedbackContextLabel` (passed as an additionalField) is used downstream
// to distinguish which feature the feedback came from.
export const FEEDBACK_COLLECTOR_ENTRYPOINT_IDS: Partial<
  Record<FeedbackContextLabel, string>
> = {
  [FEEDBACK_CONTEXT_LABELS.TESTS]: '9166709f-8cc2-4031-b47e-739155dd66bf',
  [FEEDBACK_CONTEXT_LABELS.MERGE_QUEUES]:
    '9166709f-8cc2-4031-b47e-739155dd66bf',
  [FEEDBACK_CONTEXT_LABELS.MERGE_QUEUES_SETTINGS]:
    '9166709f-8cc2-4031-b47e-739155dd66bf',
  [FEEDBACK_CONTEXT_LABELS.AGENTIC_PIPELINES]:
    '9166709f-8cc2-4031-b47e-739155dd66bf',
  [FEEDBACK_CONTEXT_LABELS.DEPLOYMENTS]: '9166709f-8cc2-4031-b47e-739155dd66bf',
};

export const FEEDBACK_CONTEXT_CUSTOM_FIELD_ID = 'customfield_10047';

export const FEEDBACK_SOURCES: Record<FeedbackContextLabel, string> = {
  [FEEDBACK_CONTEXT_LABELS.TESTS]: 'Tests Page',
  [FEEDBACK_CONTEXT_LABELS.MERGE_QUEUES]: 'Merge Queues Page',
  [FEEDBACK_CONTEXT_LABELS.MERGE_QUEUES_SETTINGS]: 'Merge Queues Setting Page',
  [FEEDBACK_CONTEXT_LABELS.AGENTIC_PIPELINES]: 'Agentic Pipelines Session Page',
  [FEEDBACK_CONTEXT_LABELS.DEPLOYMENTS]: 'Deployments Page',
};

export function buildFeedbackContextValue(label: FeedbackContextLabel): string {
  return `Source: ${FEEDBACK_SOURCES[label]}\nURL: ${window.location.href}\nUser Agent: ${window.navigator.userAgent}\nlabel: ${label}`;
}
